import detectEthereumProvider from "@metamask/detect-provider";

const Account = (
  { ethereum, imToken },
  { chainType } = { chainType: "ETHEREUM" }
) => {
  const getAddress = async () => {
    return new Promise((resolve, reject) => {
      imToken.callAPI(
        "user.showAccountSwitch",
        { chainType },
        function (err, address) {
          if (err) {
            reject(err);
          } else {
            resolve({ address });
          }
        }
      );
    });
  };

  /* istanbul ignore next */
  const getPubKey = async () => {};

  /* istanbul ignore next */
  const signTransaction = async (rawTx) => {
    const txHash = await ethereum.request({
      method: "eth_sendTransaction",
      params: [rawTx],
    });
    return { txHash };
  };

  const sign = async (message) => {
    const { address } = await getAddress();
    return ethereum.request({
      method: "personal_sign",
      params: [address, message],
    });
  };

  /* istanbul ignore next */
  const verifySignature = async (message, signature) => {};

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = ({ ethereum, imToken }) => {
  const genAccount = async (args) => Account({ ethereum, imToken }, args);

  const getAccount = async (args) => genAccount(args);

  const cleanUp = async () => {};

  return {
    getAccount,
    cleanUp,
  };
};

Backend.create = async () => {
  const ethereum = await detectEthereumProvider();
  if (!ethereum || !window.imToken) {
    throw new Error("imToken is not working.");
  }
  await ethereum.request({ method: "eth_requestAccounts" });
  return Backend({ ethereum, imToken: window.imToken });
};

export default Backend;
